/* A selection of individual sachets. Prices remain provider prices, without an assumed discount. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root || !root.document) return;
  root.GRIGMixBuilder = api;
  function mount(scope) { scope.querySelectorAll('[data-mix-builder]').forEach(api.mount); }
  mount(root.document);
  root.document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  function validQuantity(value, item) {
    return Number.isSafeInteger(value) && value >= 0 && (value === 0 ||
      (item.available && value >= item.min && value <= item.max && (value - item.min) % item.step === 0));
  }
  function nextQuantity(value, direction, item) {
    if (!item.available || !Number.isSafeInteger(value) || value < 0) return 0;
    if (direction < 0) return value <= item.min ? 0 : Math.max(item.min, value - item.step);
    var next = value === 0 ? item.min : value + item.step;
    return next <= item.max ? next : value;
  }
  function summarize(items) {
    var ids = new Set(), result = {count: 0, total: 0, items: [], valid: true};
    items.forEach(function (item) {
      if (!/^[1-9]\d*$/.test(String(item.id)) || ids.has(String(item.id)) ||
          !Number.isSafeInteger(item.price) || item.price < 0 || !validQuantity(item.quantity, item)) result.valid = false;
      ids.add(String(item.id));
      if (item.quantity > 0) {
        result.count += item.quantity;
        result.total += item.price * item.quantity;
        result.items.push({id: String(item.id), quantity: item.quantity, title: item.title});
      }
    });
    if (!Number.isSafeInteger(result.total) || !Number.isSafeInteger(result.count)) result.valid = false;
    return result;
  }
  function mount(section) {
    if (section.dataset.mixReady) return;
    section.dataset.mixReady = 'true';
    var copy;
    try { copy = JSON.parse(section.querySelector('[data-mix-copy]').textContent); } catch (error) { return; }
    var target = Math.max(1, Number(section.dataset.target) || 5);
    var form = section.querySelector('[data-mix-form]');
    var feedback = section.querySelector('[data-mix-feedback]');
    var submit = section.querySelector('[data-mix-submit]');
    var clear = section.querySelector('[data-mix-clear]');
    var inputs = section.querySelector('[data-mix-inputs]');
    var selection = section.querySelector('[data-mix-selection]');
    var progress = section.querySelector('[data-mix-progress]');
    var disclosure = section.querySelector('[data-mix-disclosure]');
    var offerSurface = section.querySelector('[data-grig-offer][data-offer-surface="mix"]');
    var localProgress = section.querySelector('[data-mix-local-progress]');
    var cartContext = section.querySelector('[data-mix-cart-context]');
    var lastOfferContext = null;
    var lastOfferSelection = '';
    var awaitingResult = false;
    var busy = false;
    var waitShown = '';
    var validationMessage = '';
    var format;
    var plural = new Intl.PluralRules(section.dataset.locale || 'en');
    try { format = new Intl.NumberFormat(section.dataset.locale || 'en', {
      style: 'currency', currency: section.dataset.currency || 'EUR',
      minimumFractionDigits: section.dataset.currency === 'CZK' ? 0 : 2, maximumFractionDigits: 2
    }); } catch (error) { return; }
    var items = Array.from(section.querySelectorAll('[data-mix-item]')).map(function (element) {
      var item = {element: element, id: element.dataset.id, title: element.dataset.title,
        price: Number(element.dataset.price), min: Number(element.dataset.min), step: Number(element.dataset.step),
        max: Number(element.dataset.max), available: element.dataset.available === 'true', quantity: 0};
      item.available = item.available && item.max >= item.min && item.min > 0 && item.step > 0;
      element.querySelector('[data-mix-control]').hidden = false;
      return item;
    });
    section.querySelector('[data-mix-summary]').hidden = false;
    function syncOffer(summary) {
      var api = window.GRIGOffers;
      if (!offerSurface || !api) return null;
      var pending = awaitingResult || !summary.valid ? [] : summary.items.map(function (item) {
        return {id: item.id, quantity: item.quantity};
      });
      var signature = JSON.stringify(pending);
      if (signature !== lastOfferSelection) {
        lastOfferSelection = signature;
        document.dispatchEvent(new CustomEvent('grig:offer-preview-change', {
          detail: {surface: offerSurface, items: pending}
        }));
      }
      var state = typeof api.getState === 'function' ? api.getState() : null;
      if (!state || !state.native || !Number.isSafeInteger(state.eligibleSachetCount)) return null;
      if (localProgress) localProgress.hidden = true;
      var message = (copy.cartSelection || '').replace('{cart}', state.eligibleSachetCount)
        .replace('{selected}', awaitingResult ? 0 : summary.count);
      if (cartContext) { cartContext.hidden = !message; cartContext.textContent = message; }
      return message;
    }
    function render(announce) {
      var summary = summarize(items);
      items.forEach(function (item) {
        var element = item.element, input = element.querySelector('[data-mix-quantity]');
        input.value = item.quantity;
        input.max = item.max;
        input.disabled = busy || !item.available;
        element.querySelector('[data-mix-minus]').disabled = busy || item.quantity === 0;
        element.querySelector('[data-mix-plus]').disabled = busy || !item.available || nextQuantity(item.quantity, 1, item) === item.quantity;
        element.querySelector('[data-mix-stock]').hidden = item.available;
        element.querySelector('[data-mix-unit-price]').textContent = format.format(item.price / 100);
        element.classList.toggle('is-selected', item.quantity > 0);
      });
      section.querySelector('[data-mix-count]').textContent = summary.count;
      section.querySelector('[data-mix-total]').textContent = format.format(summary.total / 100);
      section.querySelector('[data-mix-progress-fill]').style.transform = 'scaleX(' + Math.min(summary.count / target, 1) + ')';
      progress.setAttribute('aria-valuenow', Math.min(summary.count, target));
      progress.setAttribute('aria-valuetext', copy.count.replace('{count}', summary.count));
      var remaining = Math.max(target - summary.count, 0);
      var message = (summary.count === 0 ? copy.start : remaining === 0 ? copy.ready : remaining === 1 ? copy.oneMore : copy.remaining.replace('{count}', remaining)).replace('{target}', target);
      section.querySelector('[data-mix-progress-copy]').textContent = message;
      var offerMessage = syncOffer(summary);
      var offerState = window.GRIGOffers && typeof window.GRIGOffers.getState === 'function' ? window.GRIGOffers.getState() : null;
      section.querySelector('[data-mix-mobile-summary]').hidden = summary.count === 0 && !(offerState && offerState.eligibleSachetCount > 0);
      section.querySelector('[data-mix-mobile-count]').textContent = summary.count;
      section.querySelectorAll('[data-mix-unit]').forEach(function (element) { element.textContent = copy.units[plural.select(summary.count)] || copy.units.other; });
      section.querySelector('[data-mix-mobile-total]').textContent = format.format(summary.total / 100);
      section.querySelector('[data-mix-mobile-progress]').textContent = offerMessage || message;
      section.classList.toggle('is-complete', summary.count >= target);
      selection.replaceChildren();
      if (inputs) inputs.replaceChildren();
      summary.items.forEach(function (item, index) {
        var li = document.createElement('li'), quantity = document.createElement('strong'), title = document.createElement('span');
        quantity.textContent = item.quantity + '×';
        title.textContent = item.title;
        li.append(quantity, title); selection.append(li);
        if (inputs) ['id', 'quantity'].forEach(function (key) {
          var input = document.createElement('input'); input.type = 'hidden';
          input.name = 'items[' + index + '][' + key + ']'; input.value = item[key]; inputs.append(input);
        });
      });
      // No mix is added while the cart is pending: a change in flight, an earlier add that may
      // still land (it would be added twice), a period boundary.
      var held = !!(window.GRIGCart && window.GRIGCart.pending === true);
      if (submit) submit.disabled = busy || held || !summary.valid || summary.count === 0;
      clear.disabled = busy || summary.count === 0;
      if (form) form.setAttribute('aria-busy', String(busy));
      if (announce) feedback.textContent = offerMessage || copy.count.replace('{count}', summary.count) + ' ' + message;
      // A held add says why in its live region next to it (a wait longer than a moment), and the
      // reason goes with the wait.
      var wait = held && summary.valid && summary.count > 0 && window.GRIGCart.wait || '';
      if (wait) { if (feedback.textContent !== wait) feedback.textContent = wait; waitShown = wait; }
      else if (waitShown) { if (feedback.textContent === waitShown) feedback.textContent = ''; waitShown = ''; }
    }
    section.addEventListener('click', function (event) {
      var minus = event.target.closest('[data-mix-minus]'), plus = event.target.closest('[data-mix-plus]');
      if (busy || (!minus && !plus)) return;
      var row = (minus || plus).closest('[data-mix-item]');
      var item = items.find(function (entry) { return entry.element === row; });
      if (!item) return;
      item.quantity = nextQuantity(item.quantity, minus ? -1 : 1, item); render(true);
    });
    function editQuantity(event) {
      if (!event.target.matches('[data-mix-quantity]')) return;
      var item = items.find(function (entry) { return entry.element === event.target.closest('[data-mix-item]'); });
      var raw = event.target.value.trim(), value = Number(raw);
      if (!item) return;
      if (busy || !/^\d+$/.test(raw) || !validQuantity(value, item)) {
        // Allow clearing or composing a number, but never submit the previous
        // hidden quantity while the visible field contains an invalid draft.
        if (!busy && event.type === 'input') {
          if (submit) submit.disabled = true;
          return;
        }
        event.target.value = item.quantity; render(false); feedback.textContent = copy.invalid; return;
      }
      item.quantity = value; render(true);
    }
    section.addEventListener('input', editQuantity);
    section.addEventListener('change', editQuantity);
    clear.addEventListener('click', function () {
      if (busy) return;
      items.forEach(function (item) { item.quantity = 0; }); render(true);
    });
    if (form) {
      form.addEventListener('submit', function (event) {
        var summary = summarize(items);
        var invalidDraft = items.some(function (item) {
          var raw = item.element.querySelector('[data-mix-quantity]').value.trim();
          return !/^\d+$/.test(raw) || Number(raw) !== item.quantity;
        });
        validationMessage = '';
        if (busy || invalidDraft || !summary.valid || !summary.count) {
          event.preventDefault(); event.stopImmediatePropagation(); feedback.textContent = copy.invalid;
        } else {
          awaitingResult = true;
          syncOffer(summary);
        }
      });
      // The shared cart handler invokes this hook inside its mutation lock, before POST.
      // A refreshed quote is displayed first; it takes a second click to accept it.
      form.grigValidate = async function (cart) {
        var before = items.filter(function (item) { return item.quantity > 0; }).map(function (item) {
          return {id:item.id, price:item.price, quantity:item.quantity, min:item.min, step:item.step, max:item.max};
        });
        if (!before.length || !window.GRIGMerch || typeof window.GRIGMerch.catalog !== 'function' ||
            !cart || cart.currency !== section.dataset.currency) {
          validationMessage = copy.error; throw new Error('mix_quote_unavailable');
        }
        var catalog = await window.GRIGMerch.catalog(true);
        if (!catalog || !catalog.variants || before.some(function (item) { return !catalog.variants[item.id]; })) {
          validationMessage = copy.error; throw new Error('mix_quote_unavailable');
        }
        applyCatalog(catalog, cart);
        var changed = before.some(function (previous) {
          var current = items.find(function (item) { return item.id === previous.id; });
          return !current || current.price !== previous.price || current.quantity !== previous.quantity ||
            current.min !== previous.min || current.step !== previous.step || current.max !== previous.max ||
            !validQuantity(current.quantity, current);
        });
        if (changed) {
          validationMessage = copy.changed;
          feedback.textContent = copy.changed;
          throw new Error('mix_quote_changed');
        }
      };
    }
    document.addEventListener('grig:cart-busy', function (event) {
      busy = Boolean(event.detail && event.detail.busy);
      if (!busy && !awaitingResult && lastOfferContext && lastOfferContext.catalog) applyCatalog(lastOfferContext.catalog, lastOfferContext.cart);
      else render(false);
    });
    document.addEventListener('grig:cart-pending', function () { render(false); });
    document.addEventListener('grig:offers-updated', function (event) {
      if (!section.isConnected) return;
      lastOfferContext = event.detail || null;
      if (!busy && !awaitingResult && lastOfferContext && lastOfferContext.catalog) applyCatalog(lastOfferContext.catalog, lastOfferContext.cart);
      else render(false);
    });
    document.addEventListener('grig:cart-added', function (event) {
      if (event.detail && event.detail.form === form) {
        awaitingResult = false;
        items.forEach(function (item) { item.quantity = 0; });
        if (lastOfferContext && lastOfferContext.catalog) applyCatalog(lastOfferContext.catalog, lastOfferContext.cart);
        else render(false);
        feedback.textContent = copy.added;
      }
    });
    document.addEventListener('grig:cart-error', function (event) {
      if (event.detail && event.detail.form === form) {
        // An addition whose outcome is unknown is not a failure: the cart is being checked.
        awaitingResult = false; render(false); feedback.textContent = event.detail.unknown ? '' : validationMessage || copy.error;
      }
    });
    function openForHash() { if (window.location.hash === '#grig-mix-builder') disclosure.open = true; }
    window.addEventListener('hashchange', openForHash); openForHash();
    render(false);
    if (!items.length) feedback.textContent = copy.empty;
    function applyCatalog(catalog, cart) {
        var changed = false, existing = {};
        if (cart && Array.isArray(cart.items)) cart.items.forEach(function (item) {
          var id = String(item.variant_id || item.id);
          existing[id] = (existing[id] || 0) + Number(item.quantity || 0);
        });
        items.forEach(function (item) {
          var variant = catalog.variants[item.id], oldPrice = item.price, oldAvailable = item.available;
          if (!variant || !Number.isSafeInteger(variant.price) || variant.price < 0 || variant.requires_selling_plan) {
            item.available = false;
          } else {
            item.price = variant.price;
            var rule = variant.quantity_rule || {};
            item.min = Number(rule.min || item.min);
            item.step = Number(rule.increment || item.step);
            var cap = 99;
            if (rule.max != null) cap = Math.min(cap, Number(rule.max) - (existing[item.id] || 0));
            if (variant.max_quantity != null) cap = Math.min(cap, Number(variant.max_quantity) - (existing[item.id] || 0));
            item.max = Number.isSafeInteger(cap) ? Math.max(0, cap) : 0;
            item.available = variant.available === true && item.max >= item.min && item.min > 0 && item.step > 0;
            var unit = item.element.querySelector('.gp-unit'), measure = variant.unit_price_measurement;
            if (unit && measure && Number.isSafeInteger(variant.unit_price)) {
              unit.textContent = format.format(variant.unit_price / 100) + '/' +
                (Number(measure.reference_value) !== 1 ? measure.reference_value + ' ' : '') + measure.reference_unit;
            }
          }
          if (oldPrice !== item.price || oldAvailable !== item.available) changed = true;
          if (!validQuantity(item.quantity, item)) { item.quantity = 0; changed = true; }
        });
        render(false);
        if (changed) feedback.textContent = copy.changed;
        if (!items.some(function (item) { return item.available; })) feedback.textContent = copy.empty;
        return changed;
    }
    async function refreshCatalog(force) {
      if (!window.GRIGMerch || typeof window.GRIGMerch.catalog !== 'function' || busy) return;
      try {
        var catalog = await window.GRIGMerch.catalog(force);
        if (!catalog || !catalog.variants || !section.isConnected || busy) return;
        var state = window.GRIGOffers && typeof window.GRIGOffers.getState === 'function' ? window.GRIGOffers.getState() : null;
        applyCatalog(catalog, state && state.native || window.GRIGCart && window.GRIGCart.state);
      } catch (error) {
        // Submit always retries a fresh quote under the shared cart lock.
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { refreshCatalog(false); }, {once: true});
    else refreshCatalog(false);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCatalog(true); });
  }
  return {validQuantity: validQuantity, nextQuantity: nextQuantity, summarize: summarize, mount: mount};
});
